import React, { useState, useEffect, useRef } from 'react'
import moment from 'moment'
import { Modal, message, Tag, Button, Select, Input, Tooltip, Popover } from 'antd'
import { Link } from 'react-router-dom'
import { confirmIssue } from '../../../../services/api/apiFFM'
import { canViewStoreName as checkStoreName } from '../../../../services/StorageServices'
import { ERROR_STAGES } from '../helpers/FilterLists'
import { getIssueStageLogs } from '../../../../services/api/apiOrdersReport'
import ProductionDetailModal from './ProductionDetailModal'

const { TextArea } = Input

const TableRow = ({ item, reload, idSupplier }) => {
    const canViewStoreName = checkStoreName()
    const { package_name, push_at, namespace, type, approved_at, ffm_proof, reference_number,
        factory_info, variant_data, accepted, note, solution, status, _id } = Object.assign({}, item)
    const { name } = Object.assign({}, type)
    const { confirm, note: supplier_note, proof, confirm_at, confirm_by, error_stage } = Object.assign({}, factory_info)
    const { product_type, size } = Object.assign({}, variant_data)
    const barcode = !!reference_number && reference_number.length > 0 ? [...new Set(reference_number.map(i => `#${i.split("_")[0]}`))] : []
    // @FAC-25799 — `|| undefined` để formSubmit.error_stage giữ đúng nghĩa "chưa đụng tới" khi BE lưu null
    const errorStageCode = (error_stage && error_stage.code) || undefined
    const isLocked = status === "confirmed" || status === "done"

    const [isOpen, setIsOpen] = useState(false)
    const [isOpenDetail, setIsOpenDetail] = useState(false)
    // @FAC-25799 — mã công đoạn mà ít nhất một item của issue đã có log; null = chưa tải / tải lỗi (không lọc)
    const [stageCodesWithLogs, setStageCodesWithLogs] = useState(null)
    const [loadingStages, setLoadingStages] = useState(false)
    const [formSubmit, setFormSubmit] = useState({})
    const [loadingBtnSave, setLoadingBtnSave] = useState(false)
    const [loadingBtnConfirm, setLoadingBtnConfirm] = useState(false)
    const isOpenSaveBtn = !formSubmit.supplier_note || status === "confirmed" || status === "done"
    // @FAC-25799 — Duyệt Approve/50-50 bắt buộc chọn công đoạn lỗi
    const isErrorStageRequired = ['approve', 'half'].includes(formSubmit.supplier_confirm)
    const regexValidDriveLink = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}\/?.*$/

    const refReferenceNumber = useRef()
    const newOffsetHeight = refReferenceNumber && refReferenceNumber.current ? refReferenceNumber.current.offsetHeight : undefined
    const [showAllReferenceNumber, setShowAllReferenceNumber] = useState(false)
    const [offsetHeight, setOffsetHeight] = useState(newOffsetHeight)

    const showallonclick = () => {
        setShowAllReferenceNumber(!showAllReferenceNumber)
    }

    useEffect(() => {
        if (refReferenceNumber.current) {
            console.log(`Row height:`, refReferenceNumber.current.offsetHeight)
            setOffsetHeight(refReferenceNumber.current.offsetHeight)
        }
    }, [item])

    const renderContent = (items) => {
        return (
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
                gridColumnGap: 20
            }}>
                {
                    items.map((item, i) => (
                        <div key={`${item}_${i}`} className="barcode-item">
                            {item}
                        </div>
                    ))
                }
            </div>
        )
    }

    useEffect(() => {
        if (supplier_note || confirm || errorStageCode) setFormSubmit({
            ...formSubmit,
            supplier_note,
            supplier_confirm: confirm,
            supplier_proof: proof,
            error_stage: errorStageCode, // @FAC-25799 prefill công đoạn đã lưu nháp
        })
    }, [_id, isOpen])

    // @FAC-25799 — droplist "Công đoạn lỗi" chỉ cho chọn công đoạn mà item đã trải qua (có log)
    useEffect(() => {
        if (!isOpen || !reference_number || reference_number.length === 0) return
        let cancelled = false

        const _fetchStageCodes = async () => {
            setLoadingStages(true)
            try {
                const { data: response } = await getIssueStageLogs({ reference_numbers: reference_number })
                const { success, data } = Object.assign({}, response)
                if (!success || !Array.isArray(data)) throw new Error('stage-logs')
                const codes = new Set()
                data.forEach(i => (i.stages || []).forEach(s => (s.logs || []).length > 0 && codes.add(s.code)))
                if (!cancelled) setStageCodesWithLogs([...codes])
            } catch (e) {
                // Lỗi tải log không được chặn việc duyệt: quay về hiện đủ công đoạn
                if (!cancelled) setStageCodesWithLogs(null)
            } finally {
                if (!cancelled) setLoadingStages(false)
            }
        }

        _fetchStageCodes()

        return () => {
            cancelled = true
        }
    }, [isOpen, reference_number])

    const errorStageOptions = ERROR_STAGES.filter(stage =>
        stage.value === 'unknown' ||
        stage.value === formSubmit.error_stage || // công đoạn đã lưu nháp luôn còn trong danh sách
        !stageCodesWithLogs ||
        stageCodesWithLogs.includes(stage.value)
    )

    const hanldeOpenModal = () => {
        setIsOpen(true)
    }

    const hanldeCloseModal = () => {
        setIsOpen(false)
        setFormSubmit({})
    }

    const hanldeChangeForm = (field, value) => {
        setFormSubmit({
            ...formSubmit,
            [field]: value
        })
    }

    const renderStatus = status => {
        switch (status) {
            case 'confirmed':
                return <Tag color="#4190ff" style={{ padding: '0px 12px', borderRadius: 8 }}>confirmed</Tag>
            case 'checking':
                return <Tag color="#f59d00" style={{ padding: '0px 12px', borderRadius: 8 }}>checking</Tag>
            case 'done':
                return <Tag color="#a4a0a0" style={{ padding: '0px 12px', borderRadius: 8 }}>done</Tag>
            default:
                return ''
        }
    }

    const renderSolution = solution => {
        switch (solution) {
            case 'refund':
                return <Tag color="#ed2b2b">Refund</Tag>
            case 'replace':
                return <Tag color="#1fa135">Replace</Tag>
            default:
                return ''
        }
    }

    const renderSupplierConfirm = type => {
        switch (type) {
            case 'half':
                return <Tag color="#FF9999">50/50</Tag>
            case 'reject':
                return <Tag color="#ed2b2b">Reject</Tag>
            default:
                return <Tag color="#1fa135">Approve</Tag>
        }
    }

    const hanldeSubmit = async (type, idIssue) => {
        if (type === "save") {
            setLoadingBtnSave(true)
        } else {
            setLoadingBtnConfirm(true)
        }

        try {
            if (!!formSubmit.supplier_note && formSubmit.supplier_note.trim() === '') return message.error("Note là bắt buộc!")
            if (!!formSubmit.supplier_note && formSubmit.supplier_note.length >= 255) return message.error("Note là bắt buộc và phải ít hơn 255 ký tự!")
            if (!!formSubmit.supplier_proof && !regexValidDriveLink.test(formSubmit.supplier_proof) && formSubmit.supplier_proof.length >= 100) return message.error("Supplier's proof phải ít hơn 100 ký tự!")
            // @FAC-25799 — Duyệt Approve/50-50 bắt buộc chọn công đoạn lỗi (BE cũng chặn)
            if (type !== 'save' && isErrorStageRequired && !formSubmit.error_stage) return message.error("Vui lòng chọn công đoạn lỗi!")

            const payload = {
                supplier_confirm: formSubmit.supplier_confirm,
                supplier_note: formSubmit.supplier_note,
                // @FAC-25799 — BE chỉ nhận error_stage khi factory === 'MCVN'
                factory: 'MCVN',
            }

            if (type !== 'save') payload.final_confirm = true
            if (!!formSubmit && !!formSubmit.supplier_proof) payload.supplier_proof = formSubmit.supplier_proof.trim()
            if (isErrorStageRequired) {
                // undefined = chưa đụng tới (BE giữ nguyên); '' = user đã xoá (BE xoá)
                if (formSubmit.error_stage !== undefined) payload.error_stage = formSubmit.error_stage
            } else if (errorStageCode || formSubmit.error_stage) {
                // Ô công đoạn lỗi đang ẩn (Reject / chưa chọn kết quả): xoá công đoạn đã lưu nháp hoặc đã chọn
                // trước đó để BE không chụp log cho một công đoạn user không còn thấy
                payload.error_stage = ''
            }

            const { success, message: mess } = await confirmIssue(idIssue, payload)

            if (!success) return message.error(mess)

            type === "confirm" ? message.success("Confirm issue successfully!") : message.success("Save issue successfully!")
            reload()
        } catch (error) {
            message.error(error.message)
        } finally {
            setLoadingBtnSave(false)
            setLoadingBtnConfirm(false)
        }
    }

    const openAnyLinks = (text) => {
        const regex = /https?:\/\/[^\s]+/g
        const links = text.match(regex)
        if (links) {
            links.forEach((link, index) => {
                window.open(link, '_blank')
            })
        }
    }

    const hasLinks = (text) => {
        const regex = /https?:\/\/[^\s]+/g
        return regex.test(text)
    }

    return (
        <tr className='TableRow' key={`${item._id}`}>
            <td className="Barcode">
                <div>
                    {barcode && barcode.length > 0 && barcode.map(i => (
                        <div key={i} className="barcode">
                            <Link to="#">
                                {i}
                            </Link>
                        </div>
                    ))
                    }
                </div>
                {package_name && <div>{package_name}</div>}
                {namespace && canViewStoreName && <div style={{ color: '#b7b3b3' }}>{namespace}</div>}
                {push_at && <div style={{ color: '#b7b3b3' }}>{moment(push_at).format("HH:mm DD/MM/YYYY")}</div>}
            </td>
            <td className="BarcodeItem">
                <div className={showAllReferenceNumber === false ? "HiddenReferenceNumber" : ""}>
                    <div className="referenceNumber text-primary" ref={refReferenceNumber}>
                        {reference_number && reference_number.length > 0 && reference_number.map(i => (
                            <div key={`referenceNumber${i}`} style={{ whiteSpace: 'pre-line' }}>{i}</div>
                        ))}
                    </div>
                </div>
                {barcode.length > 0 &&
                    <div>
                        <span className="cursor-pointer text-primary" onClick={() => setIsOpenDetail(true)}>
                            Chi tiết sản xuất
                        </span>
                    </div>
                }
                {approved_at && <div style={{ color: '#b7b3b3' }}>{moment(approved_at).format("HH:mm DD/MM/YYYY")}</div>}
                {status && renderStatus(status)}
                {/* {
                    !!refReferenceNumber.current ? (
                        (refReferenceNumber.current.offsetHeight > 60 && showAllReferenceNumber === false) ?
                            <a className="float-right mr-3 text-primary">
                                <small className="float-right mr-3" onClick={showallonclick}>Show more</small>
                            </a> :
                            (refReferenceNumber.current.offsetHeight > 60 && showAllReferenceNumber === true) ?
                                <a className="float-right mr-3 text-primary">
                                    <small className="float-right mr-3" onClick={showallonclick}>Show less</small>
                                </a> : ""
                    ) : ""
                } */}
                {reference_number && reference_number.length > 3 &&
                    <Popover
                        title="Items"
                        trigger="click"
                        content={() => renderContent(reference_number)}
                        className='cursor-pointer'
                        placement={'bottom'}
                    >
                        <div>
                            <span className="cursor-pointer float-right" style={{ color: 'rgb(33, 150, 243)' }}>
                                {`Show all (${reference_number.length})`}
                            </span>
                        </div>
                    </Popover>
                }
            </td>
            <td className="ProductType">
                {product_type && <div>{product_type}</div>}
                {size && <div>{size}</div>}
            </td>
            <td className="IssueType">
                <div>{name || ''}</div>
                <div>
                    {ffm_proof ?
                        hasLinks(ffm_proof) ?
                            <div
                                className='cursor-pointer text-primary'
                                onClick={() => openAnyLinks(ffm_proof)}
                            >
                                <Tooltip title={ffm_proof}>Xem</Tooltip>
                            </div> :
                            <div className='cursor-pointer text-primary'>
                                <Tooltip title={ffm_proof}>Xem</Tooltip>
                            </div> : ''
                    }
                </div>
            </td>
            <td className="Accepted">
                {accepted ? "Yes" : "No"}
            </td>
            <td className="Note ellipsis">
                {!!note &&
                    <Tooltip placement="topLeft" title={note}>
                        <span className='cursor-pointer'>{note}</span>
                    </Tooltip>
                }
            </td>
            <td className="Solution">
                {renderSolution(solution)}
            </td>
            <td className="SupplierConfirm">
                <div className='d-flex justify-content-center'>{confirm && renderSupplierConfirm(confirm.toLowerCase())}</div>
                <div className='text-center'>
                    {proof ?
                        hasLinks(proof) ?
                            <div
                                className='cursor-pointer text-primary'
                                onClick={() => openAnyLinks(proof)}
                            >
                                <Tooltip title={proof} placement="topLeft">Xem</Tooltip>
                            </div> :
                            <div className='cursor-pointer text-primary'>
                                <Tooltip title={proof} placement="topLeft">Xem</Tooltip>
                            </div> : ''
                    }
                </div>
            </td>

            <td className="SupplierNote ellipsis">
                {!!supplier_note &&
                    <Tooltip placement="topLeft" title={supplier_note}>
                        <span className='cursor-pointer'>{supplier_note}</span>
                    </Tooltip>
                }
            </td>
            <td className="User">
                <div>{!!confirm_by && !!confirm_by.username && confirm_by.username}</div>
                <div style={{ color: '#b7b3b3' }}>{confirm_at && moment(confirm_at).format("HH:mm DD/MM/YYYY")}</div>
            </td>
            <td className="Action">
                <Tooltip placement="top" title={"Duyệt"}>
                    <i className='icon-pencil text-primary' onClick={hanldeOpenModal} />
                </Tooltip>
            </td>
            <Modal
                title={<span style={{ fontWeight: 'bold', fontSize: 20 }}>Duyệt đơn lỗi</span>}
                visible={isOpen}
                onCancel={hanldeCloseModal}
                footer={[
                    <div className='d-flex justify-content-between'>
                        <Button key="back" onClick={hanldeCloseModal} disabled={loadingBtnSave || loadingBtnConfirm}>
                            Hủy
                        </Button>
                        <div>
                            <Button
                                style={{ backgroundColor: isOpenSaveBtn ? '#f5f5f5' : '#f59d00', color: isOpenSaveBtn ? '#b8b8b8' : '#ffffff' }}
                                disabled={isOpenSaveBtn}
                                onClick={() => hanldeSubmit('save', _id)}
                                loading={loadingBtnSave}
                            >
                                Lưu nháp
                            </Button>
                            <Button
                                type="primary"
                                onClick={() => hanldeSubmit('confirm', _id)}
                                disabled={!formSubmit.supplier_confirm || status === "confirmed" || status === "done"}
                                loading={loadingBtnConfirm}
                            >
                                Duyệt
                            </Button>
                        </div>
                    </div>
                ]}
            >
                <div className="supplier-confirm mb-2">
                    <div className='font-weight-bold' style={{ fontSize: 16 }}>Kết quả duyệt</div>
                    <Select
                        placeholder="Chọn kết quả duyệt"
                        value={formSubmit.supplier_confirm || []}
                        onChange={value => hanldeChangeForm('supplier_confirm', value)}
                        style={{ width: '100%', pointerEvents: (status === "confirmed" || status === "done") ? 'none' : 'auto' }}
                    >
                        <Select.Option value="approve">Approve</Select.Option>
                        <Select.Option value="reject">Reject</Select.Option>
                        <Select.Option value="half">50/50</Select.Option>
                    </Select>
                </div>
                {isErrorStageRequired &&
                <div className="error-stage mb-2">
                    <div className='font-weight-bold' style={{ fontSize: 16 }}>
                        Công đoạn lỗi <span className="text-danger">*</span>
                    </div>
                    <Select
                        placeholder="Chọn công đoạn lỗi"
                        value={formSubmit.error_stage || undefined}
                        options={errorStageOptions}
                        loading={loadingStages}
                        allowClear
                        onChange={value => hanldeChangeForm('error_stage', value || '')}
                        style={{ width: '100%', pointerEvents: isLocked ? 'none' : 'auto' }}
                    />
                </div>
                }
                <div className="note-confirm mb-2">
                    <div className='font-weight-bold' style={{ fontSize: 16 }}>Note</div>
                    <TextArea
                        rows={3}
                        value={formSubmit.supplier_note}
                        onChange={e => hanldeChangeForm('supplier_note', e.target.value)}
                        style={{ pointerEvents: (status === "confirmed" || status === "done") ? 'none' : 'auto' }}
                    />
                </div>
                <div className="note-confirm">
                    <div className='font-weight-bold' style={{ fontSize: 16 }}>Minh chứng</div>
                    <Input
                        value={formSubmit.supplier_proof}
                        onChange={e => hanldeChangeForm('supplier_proof', e.target.value)}
                        style={{ pointerEvents: (status === "confirmed" || status === "done") ? 'none' : 'auto' }}
                    />
                </div>
            </Modal>
            <ProductionDetailModal
                visible={isOpenDetail}
                onClose={() => setIsOpenDetail(false)}
                referenceNumbers={reference_number}
            />
        </tr>
    )
}

export default TableRow